import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '@/components/Dashboard'
import MasterDashboard from '@/components/MasterDashboard'
import Student from '@/components/school/Student'
import Guardian from '@/components/school/Guardian'
import Bus from '@/components/transportation/Bus'
import Driver from '@/components/transportation/Driver'
import Supervisor from '@/components/transportation/Supervisor'
import Route from '@/components/transportation/Route'
import Incident from '@/components/report/Incident'
import Violation from '@/components/report/Violation'
import Report from '@/components/report/Report'
import Message from '@/components/report/Message'
import Trip from '@/components/report/Trip'
import Absence from '@/components/attendance/Absence'
import Gate from '@/components/attendance/Gate'
import User from '@/components/admin/User'
import Role from '@/components/admin/Role'
import Log from '@/components/admin/Log'
import StudentManage from '@/components/school/StudentManage'
import GuardianManage from '@/components/school/GuardianManage'
import BusManage from '@/components/transportation/BusManage'
import DriverManage from '@/components/transportation/DriverManage'
import SupervisorManage from '@/components/transportation/SupervisorManage'
import RouteManage from '@/components/transportation/RouteManage'
import UserManage from '@/components/admin/UserManage'
import ConfigurationManage from '@/components/school/ConfigurationManage'
import TripManage from '@/components/report/TripManage'
import Login from '@/components/Login'
import Denied from '@/components/403'
import NotFound from '@/components/404'
import ResetPassword from '@/components/ResetPassword'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/user/password/:id',
      name: 'ResetPassword',
      component: ResetPassword
    },
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard,
      meta: {requiresAuth: true}
    },
    {
      path: '/403',
      name: '403',
      component: Denied,
      meta: {requiresAuth: true}
    },
    {
      path: '/404',
      name: '404',
      component: NotFound,
      meta: {requiresAuth: true}
    },
    {
      path: '/master',
      name: 'MasterDashboard',
      component: MasterDashboard,
      meta: {requiresAuth: true}
    },
    {
      path: '/school/student',
      name: 'Student',
      component: Student,
      meta: {requiresAuth: true}
    },
    {
      path: '/school/guardian',
      name: 'Guardian',
      component: Guardian,
      meta: {requiresAuth: true}
    },
    {
      path: '/transportation/bus',
      name: 'Manage Buses',
      component: Bus,
      meta: {requiresAuth: true}
    },
    {
      path: '/transportation/driver',
      name: 'Manage Drivers',
      component: Driver,
      meta: {requiresAuth: true}
    },
    {
      path: '/transportation/supervisor',
      name: 'Manage Supervisors',
      component: Supervisor,
      meta: {requiresAuth: true}
    },
    {
      path: '/transportation/route',
      name: 'Manage Routes',
      component: Route,
      meta: {requiresAuth: true}
    },
    {
      path: '/report',
      name: 'report',
      component: Report,
      meta: {requiresAuth: true}
    },
    {
      path: '/report/incident',
      name: 'Incidents',
      component: Incident,
      meta: {requiresAuth: true}
    },
    {
      path: '/report/violation',
      name: 'Violations',
      component: Violation,
      meta: {requiresAuth: true}
    },
    {
      path: '/report/message/:id?',
      name: 'Messages',
      component: Message,
      meta: {requiresAuth: true, optional: true}
    },
    {
      path: '/report/Trip',
      name: 'Trips',
      component: Trip,
      meta: {requiresAuth: true}
    },
    {
      path: '/attendance/absence',
      name: 'Manage Absences',
      component: Absence,
      meta: {requiresAuth: true}
    },
    {
      path: '/attendance/absence/:id',
      name: 'Manage Absence',
      component: Absence,
      meta: {requiresAuth: true}
    },
    {
      path: '/attendance/gate',
      name: 'Manage Gates',
      component: Gate,
      meta: {requiresAuth: true}
    },
    {
      path: '/admin/user',
      name: 'Manage Users',
      component: User,
      meta: {requiresAuth: true}
    },
    {
      path: '/admin/role',
      name: 'Manage Roles',
      component: Role,
      meta: {requiresAuth: true}
    },
    {
      path: '/admin/role/:id',
      name: 'Manage Role',
      component: Role,
      meta: {requiresAuth: true}
    },
    {
      path: '/admin/log',
      name: 'Manage Logs',
      component: Log,
      meta: {requiresAuth: true}
    },
    {
      path: '/school/student/:id',
      name: 'Manage Student',
      component: StudentManage,
      meta: {requiresAuth: true}
    },
    {
      path: '/school/guardian/:id',
      name: 'Manage Guardian',
      component: GuardianManage,
      meta: {requiresAuth: true}
    },
    {
      path: '/school/configuration',
      name: 'Manage Configuration',
      component: ConfigurationManage,
      meta: {requiresAuth: true}
    },
    {
      path: '/transportation/bus/:id',
      name: 'Manage Bus',
      component: BusManage,
      meta: {requiresAuth: true}
    },
    {
      path: '/transportation/driver/:id',
      name: 'Manage Driver',
      component: DriverManage,
      meta: {requiresAuth: true}
    },
    {
      path: '/transportation/supervisor/:id',
      name: 'Manage Supervisor',
      component: SupervisorManage,
      meta: {requiresAuth: true}
    },
    {
      path: '/transportation/route/:id',
      name: 'Manage Route',
      component: RouteManage,
      meta: {requiresAuth: true}
    },
    {
      path: '/admin/user/:id',
      name: 'Manage User',
      component: UserManage,
      meta: {requiresAuth: true}
    },
    {
      path: '/report/trip/:id',
      name: 'Trip',
      component: TripManage,
      meta: {requiresAuth: true}
    }
  ]
})
export default router

let self = Vue.prototype
Object.defineProperty(self, '$permissions', {
  get () {
    if (self._permissions !== undefined) return self._permissions
    if (localStorage.getItem('userData') === null) return
    self._permissions = {}
    let permissions = JSON.parse(localStorage.getItem('userData')).permissions
    for (let index in router.options.routes) {
      let route = router.options.routes[index]
      if (route.meta === undefined) continue
      let path = route.path.substr(1).split('/', 2)
      for (let module in permissions) {
        let permission = permissions[module]
        if (module === path[0] && permission[path[1]] !== undefined) {
          if (self._permissions[module] === undefined) self._permissions[module] = {}
          route.meta.permissons = permission[path[1]]
          permissions[module][path[1]] = permission[path[1]]
        }
      }
    }
    return (self._permissions = permissions)
  },
  set (permissions) {
    self._permissions = permissions
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) return next({path: '/404'})
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem('userData') === null) return next({path: '/login'})
    // if ((to.path !== '/master' && window.location.pathname === '/') || window.location.pathname === to.path) return next({path: '/master'})
    if (to.meta.permissons === undefined) return next()
    let pathTo = to.path.split('/')
    pathTo.splice(0, 1)
    next()
  } else {
    next()
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js